<template>
  <span v-if="indexValue">
    <div class="text-terracotta cursor-pointer hover:underline">
      <a-popconfirm
        title="Are you sure you want to unpublish this value"
        ok-text="Yes"
        cancel-text="No"
        @confirm="onUnpublishButtonClicked()"
      >
        <font-awesome-icon
          v-if="isLast"
          icon="minus-square"
          title="Unpublish this value"
          class="text-complementaryRed cursor-pointer"
        />
      </a-popconfirm>
      <span @click="onClick()">
        {{
          indexValue.value.toLocaleString('en-us', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }}
      </span>
    </div>
    <div @click="onClick()" class="text-gray-400">
      <span v-if="indexValue.periodVariation < 0">
        <font-awesome-icon icon="long-arrow-alt-down" class="text-red-400" />
        ({{
          (-indexValue.periodVariation * 100).toLocaleString('en-us', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }})
      </span>
      <span v-else>
        <font-awesome-icon icon="long-arrow-alt-up" class="text-green-400" />
        {{
          (indexValue.periodVariation * 100).toLocaleString('en-us', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          })
        }}
      </span>
    </div>
  </span>
  <span v-else>
    <font-awesome-icon
      v-if="isCurrent"
      icon="plus-square"
      title="Publish this value"
      class="text-complementaryBlue cursor-pointer"
      @click="addValue"
    />
    <span v-else>-</span>
  </span>
</template>

<script>
export default {
  props: {
    indexValue: {
      type: Object,
      default: null,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
    addValue() {
      this.$emit('addButtonClicked')
    },
    onUnpublishButtonClicked() {
      this.$emit('unpublishButtonClicked')
    },
  },
}
</script>

<style></style>
